import {
  rankWith,
  isStringControl,
  isNumberControl,
  isIntegerControl,
  isBooleanControl,
  isEnumControl,
  isOneOfEnumControl,
  uiTypeIs,
  and,
  schemaMatches,
  RankedTester,
} from "@jsonforms/core";

import { TextControl } from "./controls/TextControl";
import { NumberControl } from "./controls/NumberControl";
import { PasswordControl } from "./controls/PasswordControl";
import { CheckboxControl } from "./controls/CheckboxControl";
import { EnumControl } from "./controls/EnumControl";
import { OneOfEnumControl } from "./controls/OneOfEnumControl";
import {
  RadioOneOfEnumControl,
  radioOneOfEnumControlTester,
} from "./controls/RadioOneOfEnumControl";
import { ArrayControl, arrayControlTester } from "./controls/ArrayControl";
import {
  MultiEnumControl,
  multiEnumControlTester,
} from "./controls/MultiEnumControl";
import { VerticalLayout } from "./layouts/VerticalLayout";
import { HorizontalLayout } from "./layouts/HorizontalLayout";
import { GroupLayout } from "./layouts/GroupLayout";
import { LabelRenderer } from "./layouts/LabelRenderer";

// Testers
export const textControlTester: RankedTester = rankWith(3, isStringControl);
export const numberControlTester: RankedTester = rankWith(3, isNumberControl);
export const integerControlTester: RankedTester = rankWith(3, isIntegerControl);
export const passwordControlTester: RankedTester = rankWith(
  4,
  and(
    isStringControl,
    schemaMatches((schema) => schema.format === "password"),
  ),
);
export const checkboxControlTester: RankedTester = rankWith(
  3,
  isBooleanControl,
);
export const enumControlTester: RankedTester = rankWith(3, isEnumControl);
export const oneOfEnumControlTester: RankedTester = rankWith(
  5,
  isOneOfEnumControl,
);
export const verticalLayoutTester: RankedTester = rankWith(
  1,
  uiTypeIs("VerticalLayout"),
);
export const horizontalLayoutTester: RankedTester = rankWith(
  1,
  uiTypeIs("HorizontalLayout"),
);
export const groupLayoutTester: RankedTester = rankWith(1, uiTypeIs("Group"));
export const labelTester: RankedTester = rankWith(1, uiTypeIs("Label"));

// Renderer entries
export const renderers = [
  { tester: textControlTester, renderer: TextControl },
  { tester: numberControlTester, renderer: NumberControl },
  { tester: integerControlTester, renderer: NumberControl },
  { tester: passwordControlTester, renderer: PasswordControl },
  { tester: checkboxControlTester, renderer: CheckboxControl },
  { tester: enumControlTester, renderer: EnumControl },
  { tester: oneOfEnumControlTester, renderer: OneOfEnumControl },
  { tester: radioOneOfEnumControlTester, renderer: RadioOneOfEnumControl },
  { tester: verticalLayoutTester, renderer: VerticalLayout },
  { tester: horizontalLayoutTester, renderer: HorizontalLayout },
  { tester: groupLayoutTester, renderer: GroupLayout },
  { tester: labelTester, renderer: LabelRenderer },
  { tester: arrayControlTester, renderer: ArrayControl },
  { tester: multiEnumControlTester, renderer: MultiEnumControl },
];
